import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Select} from "antd";
import {getSalonList, selectSalon} from "./actions";

const Option = Select.Option;

class SalonSelector extends Component {
  componentDidMount() {
    this.props.getSalonList().catch(console.warn);
  }

  _onSalonChange = (value) => {
    this.props.selectSalon(value);
  };

  render() {
    const {selectedSalonId, salonList} = this.props;
    return <Select value={selectedSalonId || undefined}
                   onChange={this._onSalonChange}
                   placeholder="Select salon"
                   style={{width: '100%'}}>
      {salonList.map(salon =>
        <Option key={salon.salonId}
                value={salon.salonId}>
          {salon.name}
        </Option>
      )}
    </Select>;
  }
}

SalonSelector.propTypes = {
  selectSalon: PropTypes.func.isRequired,
  salonList: PropTypes.array.isRequired,
  selectedSalonId: PropTypes.string.isRequired,
  getSalonList: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  salonList: state.salon.salonList,
  selectedSalonId: state.salon.selectedSalonId,
});

const mapDispatchToProps = dispatch => ({
  getSalonList: bindActionCreators(getSalonList, dispatch),
  selectSalon: bindActionCreators(selectSalon, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SalonSelector);



// WEBPACK FOOTER //
// ./src/Salon/SalonSelector.js